import { ActionIcon, Container, Divider, Flex, Grid, Group, Modal, Popover, Stack, Text, Title } from "@mantine/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoaderWrapper } from "../../../components/GeneralComponents/LoaderWrapper";
import { useForm } from "@mantine/form";
import { DotsVertical, Plus, Printer } from "tabler-icons-react";
import { useDisclosure } from "@mantine/hooks";
import AddVehicleModal from "./AddVehicleModal";
import AddBuyerModal from "./AddBuyerModal";
import TextInput from "../../../components/Input/TextInput";
import MultiCalculatorPart from "./MultiCalculatorPart";
import VehiclePriceDropdown from "./PopOverDropdowns/VehiclePriceDropdown";
import FeesDropdown from "./PopOverDropdowns/FeesDropdown";
import AccessoriesDropdown from "./PopOverDropdowns/AccessoriesDropdown";
import BackendDropdown from "./PopOverDropdowns/BackendDropdown";
import ProtectionPlanDropdown from "./PopOverDropdowns/ProtectionPlanDropdown";
import TotalTaxDropdown from "./PopOverDropdowns/TotalTaxDropdown";
import Select from "../../../components/Select/Select";
import { DatePicker } from "@mantine/dates";
import { useReactToPrint } from "react-to-print";
import { useQuery } from "react-query";
import { GetVinData } from "../../Dispatcher/AddTransportAssignment/GetVinData";
import { showNotification } from "@mantine/notifications";
import { GetUsersData } from "../../../components/GeneralComponents/GetUsersData";
import AmountFinancedDropdown from "./PopOverDropdowns/AmountFinancedDropdown";
import CommissionDropdown from "./PopOverDropdowns/CommissionDropdown";
import DocumentPrint from "./DocumentPrint";
import TradeInDropdown from "./PopOverDropdowns/TradeInDropdown";
import { Button } from "../../../components/Button/Button";
import DocumentPrintCustomer from "./DocumentPrintCustomer";
import DocumentPrintQuote from "./DocumentPrintQuote";

const DeskADeal = () => {
  const params = useParams();
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dealData, setDealData] = useState({});
  const [VINs, setVINs] = useState([]);
  const [confirmCancelDeal, setConfirmCancelDeal] = useState(false);
  const componentRef = useRef();
  const componentRef2 = useRef();
  const componentRef3 = useRef();
  const location = useLocation();
  const [opened, { open, close }] = useDisclosure();

  useEffect(() => {
    if (location.state) {
      const values = form.values;
      const customerObject = location.state.customerObject || {};
      customerObject.cellPhone = customerObject.cellPhone || customerObject.phoneNumber;
      const vehicleObject = location.state.vehicleObject || {};
      vehicleObject.variant =
        vehicleObject.variant ||
        (vehicleObject.trim + " " + vehicleObject.vehicleType + " " + vehicleObject.driveTrain)
          .trim()
          .replace("  ", " ")
          .replace(/undefined/g, "");
      vehicleObject.stockNumber = vehicleObject.stockNumber || vehicleObject.stock;
      vehicleObject.vehicleVIN = vehicleObject.vehicleVIN || vehicleObject.VIN;
      vehicleObject.mileage = vehicleObject.mileage || 0;
      vehicleObject.vehicleRetailPrice =
        typeof vehicleObject.vehicleRetailPrice === "string"
          ? parseFloat(vehicleObject.vehicleRetailPrice.replace(/[^0-9.-]+/g, ""))
          : vehicleObject.vehicleRetailPrice;
      form.setValues({
        ...values,
        ...customerObject,
        ...vehicleObject,
      });
    }
  }, [location.state]);

  const {
    isLoading: vehiclesIsLoading,
    isFetching: vehiclesIsFetching,
    data: vehicles,
  } = useQuery("vehiclesForDealDesk", () => GetVinData({ url: `/vehicle` }), {
    onError: (error) => {
      showNotification({
        title: "Error",
        message: `${error.response?.data?.message || error.message}`,
        color: "red",
      });
    },
  });

  const {
    isLoading: customersIsLoading,
    isFetching: customersIsFetching,
    data: customers,
  } = useQuery("customersForDealDesk", () => GetUsersData({ url: `/customers` }), {
    onError: (error) => {
      showNotification({
        title: "Error",
        message: `${error.response?.data?.message || error.message}`,
        color: "red",
      });
    },
  });

  const form = useForm({
    initialValues: {
      vehicleTitle: "",
      VIN: "",
      make: "",
      model: "",
      year: "",
      color: "",
      vehicleRetailPrice: 0,
      vehicleCostPrice: 0,
      fees: 774,
      backend: 0,
      accessoriesPrice: 0,
      accessoriesCost: 0,
      accessories: [],
      protectionPlan: {},
      protectionPlanPrice: 0,
      totalTax: 0,
      taxPercentage: 6,
      downPayment: 1000,
      tradeIn: 0,
      tradeInPayoff: 0,
      netTradeIn: 0,
      licenseFee: 20,
      registrationFee: 187,
      titleFee: 100,
      lienFee: 20,
      inspectionFee: 0,
      dealerProcessingFee: 499,
      dealerProcessingFeeItemized: 0,
      freightCharges: 0,
      lenderProcessingFee: 0,
      GAP: 0,
      VSI: 0,
      amountFinanced: 0,
      frequency: "Monthly",
      monthlyPayment: 0,
      firstPayment: new Date(),
      buyRate: 0,
      totalPrice: 0,
      term: 36,
      APR: 9,
      financeCharges: 0,
      frontGross: 0,
      backGross: 0,
      totalCommission: 0,
      docFee: 499,
      commissions: {
        salesPerson1: {
          frontGross: 0,
          backGross: 0,
        },
        salesPerson2: {
          frontGross: 0,
          backGross: 0,
        },
        salesManager: {
          frontGross: 0,
          backGross: 0,
        },
        financeManager: {
          frontGross: 0,
          backGross: 0,
        },
      },
    },
    downPayments: [0, 0, 0],
    APRs: [0, 0, 0],
    terms: [0, 0, 0],
    selectedIndex: [0, 0],
  });

  useEffect(() => {
    const grossOnVehicle = form.values.vehicleRetailPrice - form.values.vehicleCostPrice;
    const grossOnAccessories = form.values.accessoriesPrice - form.values.accessoriesCost;
    const totalGross = grossOnVehicle + grossOnAccessories;
    form.setFieldValue("frontGross", totalGross);
  }, [form.values.totalPrice, form.values.vehicleCostPrice, form.values.accessoriesCost, form.values.accessoriesPrice]);

  useEffect(() => {
    const gapAndVsi =
      (isNaN(parseFloat(form.values.GAP)) ? 0 : parseFloat(form.values.GAP)) +
      (isNaN(parseFloat(form.values.VSI)) ? 0 : parseFloat(form.values.VSI));

    const totalBackend = form.values.protectionPlanPrice + gapAndVsi;

    form.setFieldValue("backend", totalBackend);
  }, [form.values.GAP, form.values.VSI]);

  useEffect(() => {
    // add all fees together and set the total fees
    const backend = form.values.backend || 0;
    const accessoriesPrice = form.values.accessoriesPrice || 0;
    const protectionPlanPrice = form.values.protectionPlanPrice || 0;
    const totalTax = form.values.totalTax || 0;
    const vehicleRetailPrice = form.values.vehicleRetailPrice || 0;
    const downPayment = form.values.downPayment || 0;
    const tradeIn = form.values.tradeIn || 0;
    const totalFees = form.values.fees || 0;
    const term = form.values.term || 0;
    const tradeInPayoff = form.values.tradeInPayoff || 0;

    // parse the values to float and check if they are NaN
    const backendFloat = isNaN(parseFloat(backend)) ? 0 : parseFloat(backend);
    const accessoriesPriceFloat = isNaN(parseFloat(accessoriesPrice)) ? 0 : parseFloat(accessoriesPrice);
    const protectionPlanPriceFloat = isNaN(parseFloat(protectionPlanPrice)) ? 0 : parseFloat(protectionPlanPrice);
    const totalTaxFloat = isNaN(parseFloat(totalTax)) ? 0 : parseFloat(totalTax);
    const vehicleRetailPriceFloat = isNaN(parseFloat(vehicleRetailPrice)) ? 0 : parseFloat(vehicleRetailPrice);
    const downPaymentFloat = isNaN(parseFloat(downPayment)) ? 0 : parseFloat(downPayment);
    const tradeInFloat = isNaN(parseFloat(tradeIn)) ? 0 : parseFloat(tradeIn);
    const totalFeesFloat = isNaN(parseFloat(totalFees)) ? 0 : parseFloat(totalFees);
    const termInt = isNaN(parseInt(term)) ? 0 : parseInt(term);
    const tradeInPayoffFloat = isNaN(parseFloat(tradeInPayoff)) ? 0 : parseFloat(tradeInPayoff);

    // calculate the amount financed
    const amountFinanced =
      vehicleRetailPriceFloat +
      totalTaxFloat +
      totalFeesFloat +
      backendFloat +
      accessoriesPriceFloat +
      protectionPlanPriceFloat -
      downPaymentFloat -
      tradeInFloat +
      tradeInPayoffFloat;

    form.setFieldValue("amountFinanced", amountFinanced.toFixed(2));
    form.setFieldValue("netTradeIn", tradeInFloat - tradeInPayoffFloat);

    // calculate the monthly payment
    // const monthlyPayment = termInt > 0 ? amountFinanced / termInt : 0;
    // form.setFieldValue("monthlyPayment", monthlyPayment);

    // calculate the total price
    const totalPrice =
      vehicleRetailPriceFloat + totalTaxFloat + backendFloat + accessoriesPriceFloat + protectionPlanPriceFloat + totalFeesFloat;
    form.setFieldValue("totalPrice", totalPrice.toFixed(2));
  }, [
    form.values.backend,
    form.values.accessoriesPrice,
    form.values.protectionPlanPrice,
    form.values.totalTax,
    form.values.vehicleRetailPrice,
    form.values.downPayment,
    form.values.tradeIn,
    form.values.fees,
    form.values.term,
    form.values.tradeInPayoff,
  ]);

  useEffect(() => {
    const principal = form.values.amountFinanced;
    const annualInterestRate = form.values.APR / 100;
    const numberOfPayments = form.values.term;
    const paymentAmount = form.values.monthlyPayment;
    const frequency = form.values.frequency; // Assuming a field for payment frequency is added

    // Calculate number of payments per year based on frequency
    let paymentsPerYear;
    switch (frequency) {
      case "Weekly":
        paymentsPerYear = 52;
        break;
      case "Bi-Weekly":
        paymentsPerYear = 26;
        break;
      case "Semi-Monthly":
        paymentsPerYear = 24;
        break;
      case "Monthly":
        paymentsPerYear = 12;
        break;
      default:
        // Handle invalid frequency or provide a default value
        paymentsPerYear = 12; // Assuming monthly as default
    }

    // Calculate monthly interest rate based on annual rate and frequency
    const monthlyInterestRate = annualInterestRate / paymentsPerYear;

    // Calculate finance charges
    let remainingPrincipal = principal;
    let totalInterest = 0;

    for (let i = 0; i < numberOfPayments; i++) {
      const interest = remainingPrincipal * monthlyInterestRate;
      totalInterest += interest;
      const principalPaid = paymentAmount - interest;
      remainingPrincipal -= principalPaid;
    }

    totalInterest = totalInterest.toFixed(2);
    form.setFieldValue("financeCharges", totalInterest);
  }, [form.values.amountFinanced, form.values.APR, form.values.term, form.values.monthlyPayment, form.values.frequency]);

  useEffect(() => {
    const vehiclePrice = form?.values?.vehicleRetailPrice ? parseInt(form?.values?.vehicleRetailPrice) : 0;
    const dealerProcessingFee = form?.values?.dealerProcessingFee ? parseInt(form?.values?.dealerProcessingFee) : 0;
    const freightCharges = form?.values?.freightCharges ? parseInt(form?.values?.freightCharges) : 0;
    const tradeIn = form?.values?.tradeIn ? parseInt(form?.values?.tradeIn) : 0;
    const taxPercentage = form?.values?.taxPercentage ? parseInt(form?.values?.taxPercentage) : 0;
    const totalTax = (vehiclePrice + dealerProcessingFee + freightCharges - tradeIn) * (taxPercentage / 100);
    form.setFieldValue("totalTax", totalTax.toFixed(2));
  }, [form.values.vehicleRetailPrice, form.values.taxPercentage]);

  const handlePrint = useReactToPrint({
    // documentTitle: "Print",
    content: () => componentRef.current,
    // copyStyles: true,
    pageStyle: { margin: "10px" },
  });

  const handlePrintCustomer = useReactToPrint({
    // documentTitle: "Print",
    content: () => componentRef2.current,
    // copyStyles: true,
    pageStyle: { margin: "10px" },
  });
  const extractTrimmedString = useCallback((str) => {
    if (str === null || str === undefined) {
      return "";
    }
    return str?.trim()?.replace("  ", " ") + " ";
  }, []);

  const handlePrintQuote = useReactToPrint({
    // documentTitle: "Print",
    content: () => componentRef3.current,
    copyStyles: true,
    pageStyle: { margin: "10px" },
  });

  return (
    <Container
      size={1980}
      pos="relative"
      style={{
        overflow: "auto",
        height: "100%",
      }}
    >
      <LoaderWrapper loading={loading}>
        <form
          style={{
            minWidth: 1200,
          }}
        >
          <Grid gutter={"xl"}>
            <Grid.Col span={4}>
              <DisplayDetails
                title={form.values.vehicleTitle || "Select A Vehicle"}
                values={{
                  "Stock #": form.values?.vehicleVIN?.slice(-6) || "N/A",
                  "": form.values.variant || "N/A",
                }}
                ModalView={
                  <AddVehicleModal
                    key={"add-vehicle-modal"}
                    form={form}
                    vehicles={vehicles}
                    isLoading={vehiclesIsLoading}
                    isFetching={vehiclesIsFetching}
                  />
                }
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <DisplayDetails
                title={
                  form.values.fullName ||
                  (
                    extractTrimmedString(form.values?.firstName) +
                    extractTrimmedString(form.values?.middleName) +
                    extractTrimmedString(form.values?.lastName)
                  )
                    .replace("  ", " ")
                    .trim() ||
                  "Add A Buyer"
                }
                values={{
                  "Phone #": form.values.cellPhone || "N/A",
                  "Monthly Income": "N/A",
                }}
                ModalView={
                  <AddBuyerModal
                    key={"add-buyer-modal"}
                    form={form}
                    customers={customers}
                    isLoading={customersIsLoading}
                    isFetching={customersIsFetching}
                  />
                }
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <DisplayDetails
                title={
                  form.values.coBuyerFullName ||
                  (
                    extractTrimmedString(form.values?.coBuyerFirstName) +
                    extractTrimmedString(form.values?.coBuyerMiddleName) +
                    extractTrimmedString(form.values?.coBuyerLastName)
                  )
                    .replace("  ", " ")
                    .trim() ||
                  "Add A Co-Buyer"
                }
                values={{
                  "Phone #": form.values.coBuyerCellPhone || "N/A",
                  "Monthly Income": "N/A",
                }}
                ModalView={
                  <AddBuyerModal
                    key={"add-co-buyer-modal"}
                    form={form}
                    coBuyer={true}
                    customers={customers}
                    isLoading={customersIsLoading}
                    isFetching={customersIsFetching}
                  />
                }
              />
            </Grid.Col>
          </Grid>

          <Divider my={"xl"} />

          <Flex gap={"xl"}>
            <Stack
              style={{
                flex: 3,
                minWidth: 300,
              }}
            >
              <Title order={4}>Structure</Title>
              <Divider />
              <StructureInput
                label="Price"
                form={form}
                validateName={"vehicleRetailPrice"}
                positive
                popoverDropdown={<VehiclePriceDropdown form={form} />}
              />
              <StructureInput
                label="Fees"
                form={form}
                validateName={"fees"}
                positive
                popoverDropdown={<FeesDropdown form={form} />}
                disabled
              />
              <StructureInput
                label="Ins / GAP / VSI"
                form={form}
                validateName={"backend"}
                positive
                popoverDropdown={<BackendDropdown form={form} />}
                disabled
              />
              <StructureInput
                label="Accessories"
                form={form}
                validateName={"accessoriesPrice"}
                positive
                popoverDropdown={<AccessoriesDropdown form={form} />}
                disabled
              />
              <StructureInput
                label="VSC / Products"
                form={form}
                validateName={"protectionPlanPrice"}
                positive
                popoverDropdown={<ProtectionPlanDropdown form={form} />}
                disabled
              />
              <StructureInput
                label="Total Tax"
                form={form}
                validateName={"totalTax"}
                positive
                popoverDropdown={<TotalTaxDropdown form={form} />}
                disabled
              />
              <StructureInput label="Down Payment" positive={false} form={form} validateName={"downPayment"} negative showOptions={false} />
              <StructureInput
                label="Trade In"
                positive={false}
                form={form}
                validateName={"netTradeIn"}
                negative
                disabled
                popoverDropdown={<TradeInDropdown form={form} />}
              />
              <Divider />
              <StructureInput
                label="Amount Financed"
                form={form}
                validateName={"amountFinanced"}
                disabled
                popoverDropdown={<AmountFinancedDropdown form={form} />}
              />
              <StructureSelect
                label="Frequency"
                form={form}
                validateName={"frequency"}
                data={[
                  { value: "Monthly", label: "Monthly" },
                  { value: "Semi-Monthly", label: "Semi-Monthly" },
                  { value: "Bi-Weekly", label: "Bi-Weekly" },
                  { value: "Weekly", label: "Weekly" },
                ]}
              />
              <StructureInput label="Monthly Payment" form={form} validateName={"monthlyPayment"} disabled showOptions={false} />
              <StructuredDateInput label="First Payment" form={form} validateName={"firstPayment"} />
              <StructureInput label="Buy Rate" form={form} validateName={"buyRate"} showOptions={false} />
            </Stack>
            <Divider orientation="vertical" />
            <Stack
              style={{
                flex: 6,
                minWidth: 500,
              }}
            >
              <Title order={4}>Payment Options</Title>
              <Divider />
              <MultiCalculatorPart form={form} />
              <Group position="center">
                <Button size="sm" onClick={handlePrintQuote}>
                  Print Quote
                </Button>
                <Button size="sm" onClick={handlePrint}>
                  Print For Dealer
                </Button>
                <Button size="sm" onClick={handlePrintCustomer}>
                  Print For Customer
                </Button>
              </Group>
            </Stack>
            <Divider orientation="vertical" />
            <Stack
              style={{
                flex: 3,
                minWidth: 220,
              }}
            >
              <Group position="apart">
                <Title order={4}>Deal Summary</Title>
                <Printer
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={open}
                />
              </Group>
              <Divider />
              <Group position="apart" align="center">
                <FloatingText value={form.values.downPayment || 0} prefix={"$"} text={"Down"} />
                <FloatingText value={form.values.term || 0} text={"Term"} decimal={false} />
              </Group>
              <Group position="apart" align="center">
                <FloatingText value={form.values.APR || 0} postfix={"%"} text={"APR"} />
                <FloatingText
                  value={form.values.monthlyPayment || 0}
                  prefix={"$"}
                  text={
                    form.values.frequency === "Monthly"
                      ? "/months"
                      : form.values.frequency === "Semi-Monthly"
                        ? "/semi-mths"
                        : form.values.frequency === "Bi-Weekly"
                          ? "/bi-weeks"
                          : form.values.frequency === "Weekly"
                            ? "/weeks"
                            : ""
                  }
                />
              </Group>
              <Divider />
              <GroupedDisplay title={"Amount Financed"} value={form.values.amountFinanced} />
              <GroupedDisplay title={"Finance Charges"} value={form.values.financeCharges} />
              <GroupedDisplay title={"Deal Costs"} value={0} />
              <Divider />
              <GroupedDisplay title={"Back Gross"} value={form.values.backGross} />
              <GroupedDisplay title={"Front Gross"} value={form.values.frontGross} />
              <GroupedDisplay title={"Total Gross"} value={form.values.frontGross - form.values.backGross} />
              <Divider />
              <GroupedDisplay
                title={"Commission"}
                value={form.values.totalCommission}
                showOptions
                popoverDropdown={<CommissionDropdown form={form} />}
              />
              <GroupedDisplay title={"Doc Fee"} value={form.values.docFee} />
              <GroupedDisplay
                title={"Net Profit"}
                value={form.values.frontGross - form.values.backGross + form.values.dealerProcessingFee + form.values.totalCommission}
              />
            </Stack>
          </Flex>
        </form>
        <DocumentPrint ref={componentRef} data={form.values} dealership="Rons" />
        <DocumentPrintCustomer ref={componentRef2} data={form.values} dealership="Rons" />
        <DocumentPrintQuote ref={componentRef3} data={form.values} dealership="Rons" />
      </LoaderWrapper>
      <Modal centered opened={opened} onClose={close} title="Print Deal Summary" size={"xs"}>
        <Stack>
          <Button size="sm" onClick={handlePrint}>
            Print Dealer Version
          </Button>
          <Button size="sm" onClick={handlePrintCustomer}>
            Print Customer Version
          </Button>
        </Stack>
      </Modal>
    </Container>
  );
};

const FloatingText = ({ value, text, decimal = true, prefix, postfix }) => {
  return (
    <Flex gap={"xs"}>
      <Text fz={"lg"} fw={700}>
        {prefix}
        {value != null ? (decimal ? parseFloat(value).toFixed(2) : value) : "N/A"}
        {postfix}
      </Text>
      <Text fz={12} mt={2}>
        {text}
      </Text>
    </Flex>
  );
};

const GroupedDisplay = ({ title, value, showOptions = false, popoverDropdown }) => {
  return (
    <Group position="apart">
      <Text fz={"sm"}>{title}</Text>
      <Group spacing={1}>
        <Text fz={"sm"}>
          {parseFloat(value).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </Text>
        {showOptions && (
          <Popover position="left-start" offset={0}>
            <Popover.Target>
              <ActionIcon size={"sm"}>
                <DotsVertical />
              </ActionIcon>
            </Popover.Target>
            <Popover.Dropdown
              p={"xs"}
              style={{
                boxShadow: "0 0 3px rgba(0,0,0,0.1)",
                border: "1px solid rgba(0,0,0,0.2)",
              }}
            >
              {popoverDropdown}
            </Popover.Dropdown>
          </Popover>
        )}
      </Group>
    </Group>
  );
};

const StructureSelect = ({ label, form, validateName, options, disabled = false, data }) => {
  return (
    <Flex gap={"md"} align={"center"}>
      <Group
        align="center"
        position="apart"
        style={{
          flex: 1,
        }}
      >
        <Text fz="sm">{label}</Text>
      </Group>
      <Select
        size="xs"
        style={{
          flex: 1,
        }}
        // type="number"
        // defaultValue={0}
        form={form}
        validateName={validateName}
        disabled={disabled}
        data={data}
      />
    </Flex>
  );
};

const StructuredDateInput = ({ label, form, validateName, disabled = false }) => {
  return (
    <Flex gap={"md"} align={"center"}>
      <Group
        align="center"
        position="apart"
        style={{
          flex: 1,
        }}
      >
        <Text fz="sm">{label}</Text>
      </Group>
      <DatePicker
        size="xs"
        style={{
          flex: 1,
        }}
        // type="number"
        // defaultValue={0}

        disabled={disabled}
        minDate={new Date()}
        {...form.getInputProps(validateName)}
      />
    </Flex>
  );
};

const StructureInput = ({
  label,
  positive,
  negative,
  validateName,
  form,
  showOptions = true,
  popoverDropdown,
  disabled = false,
  values,
}) => {
  const [opened, setOpened] = useState(false);

  return (
    <Flex gap={"md"} align={"center"}>
      <Group
        align="center"
        position="apart"
        style={{
          flex: 1,
        }}
      >
        <Text fz="sm">{label}</Text>
        <Text fz={"sm"}>{positive ? "+" : negative ? "−" : ""}</Text>
      </Group>
      <TextInput
        size="xs"
        style={{
          flex: 1,
        }}
        // type="number"
        // defaultValue={0}
        form={form}
        values={values}
        validateName={validateName}
        disabled={disabled}
        rightSection={
          showOptions && (
            <Popover opened={opened} onChange={setOpened} position="right-start" offset={5}>
              <Popover.Target>
                <ActionIcon
                  h={"95%"}
                  size={"xs"}
                  onClick={() => {
                    setOpened(!opened);
                  }}
                >
                  <DotsVertical />
                </ActionIcon>
              </Popover.Target>
              <Popover.Dropdown
                p={"xs"}
                style={{
                  boxShadow: "0 0 3px rgba(0,0,0,0.1)",
                  border: "1px solid rgba(0,0,0,0.2)",
                }}
              >
                {popoverDropdown}
              </Popover.Dropdown>
            </Popover>
          )
        }
        rightSectionWidth={showOptions && 25}
      />
    </Flex>
  );
};

const DisplayDetails = ({ title, values, ModalView }) => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <Stack
      style={{
        border: "1px solid #000",
        padding: "10px",
        cursor: "pointer",
        minWidth: 300,
        height: "100%",
        "&:hover": {
          boxShadow: "0 0 10px #000",
        },
      }}
    >
      <Group position="apart" noWrap>
        <Text fw={600}>{title}</Text>
        <ActionIcon
          onClick={() => {
            open();
          }}
        >
          <Plus />
        </ActionIcon>
      </Group>
      <Group noWrap spacing={"xs"}>
        {Object.entries(values).map(([key, value], index) => (
          <>
            <Text key={title + key + index} fz={"sm"} fw={500}>
              {key ? key + ":" : ""} {value}
            </Text>
            {index !== Object.entries(values).length - 1 && <Divider key={title + key + index} orientation="vertical" />}
          </>
        ))}
      </Group>

      <Modal opened={opened} onClose={close} centered size={"xl"}>
        {ModalView}
      </Modal>
    </Stack>
  );
};

export default DeskADeal;
